import { render } from "./Initialization.vue?vue&type=template&id=53d9c587&scoped=true&ts=true"
import script from "./Initialization.vue?vue&type=script&lang=ts"
export * from "./Initialization.vue?vue&type=script&lang=ts"

import "./Initialization.vue?vue&type=style&index=0&id=53d9c587&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d9c587"]])

export default __exports__